import React, { createContext, useContext, useState } from "react";

export const AppPropertiesContext = createContext({
  tests: [],
  addDataToTests: () => {},
  getTestDahboardById: () => {},
  getTestFooter: () => {},
  registrationForms: [],
  addRegistrationForms: () => {},
  getCenterAdressById: () => {},
  hideStudentDossier: false,
  addHideStudentDossier: () => {},
  loginText1: null,
  addLoginText1: () => {},
  addAppProperties: () => {},
  appPropertiesLoaded: false,
  markAppPropertiesLoaded: () => {},
  getFooterConfig: () => null,
  getUITheme: () => {},
  getLrsConfig: () => {},
  navbarRedirections: () => {},
  suppressEnquiryPicker: () => {},
  getNavbarLogoHtml: ()=> {},
  getHeaderLogoUrl: ()=> {},
  getNavbarPin: ()=> {},
  getCopyrightContactEmails: ()=> {},
  getRetrictLanguageTo: ()=> {},
  getNavbarFeatures: ()=> {},
  getJudge0Config: ()=> {},
  getKidsModeConfig: ()=> {},
  getLoginPageConfig: ()=> {},
});

// Defaults applied when a tenant's app-properties.json has no `loginPage` block
// yet (i.e. hasn't migrated from customer_detail_master.iLearnAppConfig.loginPageConfig).
// String "true"/"false" values mirror the legacy DB format so existing
// comparisons (=== "true") keep working without coercion.
const LOGIN_PAGE_DEFAULTS = {
  LOGIN_TITLE: "",
  REGISTER_TITLE: "",
  LOGIN_BUTTON_TITLE: "LOGIN",
  REGISTER_BUTTON_TITLE: "REGISTER",
  SHOW_REGISTER_BUTTON: "false",
  FACEBOOK_LOGIN: "false",
  MICROSOFT_LOGIN: "false",
  FACEBOOK_LOGIN_BUTTON_TITLE: "SIGNUP WITH FACEBOOK",
  HELP_MESSAGE: "",
  BACKGROUND_IMG_URL: "",
  desktopHeroImage: [],
  registrationFormId: null,
  // New register-link visibility flags. Default true to preserve current
  // hardcoded-visible behavior on tenants that haven't opted into the new block.
  showParentRegisterLink: true,
  showAlumniRegisterLink: true,
};

export const AppPropertiesProvider = ({ children }) => {
  const [tests, setTests] = useState([]);
  const [loginText1, setloginText1] = useState(null);
  const [registrationForms, setRegistrationForms] = useState([]);
  const [hideStudentDossier, setHideStudentDossier] = useState(false);
  const [appProperties, setAppProperties] = useState({});
  // True once the app-properties.json fetch has settled (success OR failure) —
  // lets consumers (Footer) distinguish "not loaded yet" from "no key present".
  const [appPropertiesLoaded, setAppPropertiesLoaded] = useState(false);

  const getUITheme = () => {
    console.log(appProperties, "heree");
    if (appProperties.uiTheme) {
      return appProperties.uiTheme;
    }

    return null;
  };

  const addAppProperties = (value) => {
    setAppProperties(value || {});
    setAppPropertiesLoaded(true);
  };

  // Called when the app-properties fetch fails — marks the load settled
  // without clobbering anything already stored.
  const markAppPropertiesLoaded = () => setAppPropertiesLoaded(true);

  const addLoginText1 = (value) => {
    setloginText1(value);
  };

  const addHideStudentDossier = (value) => {
    setHideStudentDossier(value);
  };

  const addDataToTests = (testDetails) => {
    setTests(testDetails);
  };

  const getTestDahboardById = (id) => {
    for (let test of tests) {
      if (test.CategoryId === id) {
        if (test.CumulativeDashboarId || test.CumulativeDashboarId === 0) {
          return test.CumulativeDashboarId;
        } else return null;
      }
    }
    return null;
  };

  const getTestFooter = (id) => {
    console.log(id);
    for (let test of tests) {
      if (test.CategoryId === id) {
        if (test.footer) {
          return test.footer;
        } else return null;
      }
    }
    return null;
  };

  const addRegistrationForms = (formData) => {
    setRegistrationForms(formData);
  };

  const getCenterAdressById = (formId, centerId) => {
    console.log(formId, centerId);
    for (let form of registrationForms) {
      if (form["form-id"] === formId) {
        for (let center of form.preferredCentres) {
          if (center.id === centerId) {
            return center.address;
          }
        }
      }
    }
    return null;
  };

  const getReadLrsConfig = () => {
    if (appProperties.lrsConfig?.read) {
      return appProperties.lrsConfig.read;
    }

    return null;
  };

  const getWriteLrsConfig = () => {
    if (appProperties.lrsConfig?.write) {
      return appProperties.lrsConfig.write;
    }

    return null;
  };
  const navbarRedirections = () => {
    return appProperties?.navbar?.navbarLinks || [];
  };

  const suppressEnquiryPicker = () =>
    appProperties.fixEnrollmentContextOnLogin || false;

  const getNavbarLogoHtml = () => appProperties.navbarHtml || null;
  const getHeaderLogoUrl = () =>
    appProperties.branding?.headerLogoUrl ||
    appProperties.branding?.iLearnPrimaryLogoUrl ||
    null;
  const getNavbarPin = () => appProperties.navbarPin || null;

  const getCopyrightContactEmails = ()=> appProperties.copyrightDetails?.contactEmail || null;

  // Footer block written by iteach Tenant Preferences → Footer
  // ({ mode: "structured"|"html", structured?, html? }). Null = unconfigured —
  // Footer falls back to legacy staticfiles footer.html, then built-in default.
  const getFooterConfig = () => appProperties.footer || null;

  const getRetrictLanguageTo = () => appProperties.retrictLanguageTo || null;

  const getNavbarFeatures = () => {
    const features = appProperties?.navbar?.features;
    return {
      showAccessibility: features?.showAccessibility ?? true,
      showGIGW: features?.showGIGW ?? true,
      showLanguageSwitcher: features?.showLanguageSwitcher ?? true,
    };
  };

  const getJudge0Config = () => {
    return appProperties?.judge0Config || null;
  };

  const getKidsModeConfig = () => {
    return appProperties?.kidsMode || null;
  };

  const getLoginPageConfig = () => ({
    ...LOGIN_PAGE_DEFAULTS,
    ...(appProperties?.loginPage || {}),
  });

  const value = {
    tests,
    registrationForms,
    addDataToTests,
    getTestDahboardById,
    getTestFooter,
    addRegistrationForms,
    getCenterAdressById,
    hideStudentDossier,
    addHideStudentDossier,
    loginText1,
    addLoginText1,
    addAppProperties,
    appProperties,
    appPropertiesLoaded,
    markAppPropertiesLoaded,
    getFooterConfig,
    getUITheme,
    getReadLrsConfig,
    getWriteLrsConfig,
    navbarRedirections,
    suppressEnquiryPicker,
    getNavbarLogoHtml,
    getHeaderLogoUrl,
    getNavbarPin,
    getCopyrightContactEmails,
    getRetrictLanguageTo,
    getNavbarFeatures,
    getJudge0Config,
    getKidsModeConfig,
    getLoginPageConfig,
  };

  return (
    <AppPropertiesContext.Provider value={value}>
      {children}
    </AppPropertiesContext.Provider>
  );
};

// HOC for class components that already have a different `contextType` set
// (e.g. home/desktop uses MsalContext). Injects `loginPageConfig` as a prop.
export const withLoginPageConfig = (Comp) => {
  const Wrapped = (props) => {
    const { getLoginPageConfig } = useContext(AppPropertiesContext);
    return <Comp {...props} loginPageConfig={getLoginPageConfig()} />;
  };
  Wrapped.displayName = `withLoginPageConfig(${Comp.displayName || Comp.name || "Component"})`;
  return Wrapped;
};
